
















import Vue from 'vue';
import Validation from '../../mixins/validation';
export default Vue.extend({
	name: 'FieldText', 
	props: {
		validateNow: Boolean, 
		name: String, 
		label: String, 
		value: String, 
		rules: Array, 
		rows: Number,
		disabled: Boolean
	},
	data(): any {
		return {
			field: {
				value: null, 
				isValid: false, 
				isDirty: false
			}
		};
	}, 
	methods: {
		handleFieldBlur(): void {
			Validation.setFieldValid(this.field, this.rules)
			this.handleFieldInput();
			this.$emit('blur', this.field.isValid);
		},
		handleFieldFocus(): void {
			this.$emit('focus');
		}, 
		handleFieldInput(): void {
			this.field.isDirty = true;
			this.$emit('input', this.field.isValid ? this.field.value : '');
		}
	}, 
	mounted(){
		if (this.value){
			this.field.value = this.value;
			this.field.isValid = true;
			this.field.isDirty = true;
		}
	}
});
